// extracted by mini-css-extract-plugin
module.exports = {"score":"styles-module__score___2CKZ9"};